// extracted by mini-css-extract-plugin
module.exports = {"AddToShoppingCartButton":"AddToShoppingCartButton_AddToShoppingCartButton__EU_uG","AddToShoppingCartButtonInCart":"AddToShoppingCartButton_AddToShoppingCartButtonInCart__GCLcc"};